import { FormSection } from 'framework/ui/layout';
import useKPIService, { KPI_TYPES_UNIT_OPTIONS, UpdateValueType } from '../../useKPIService';
import { TextInput, ModalFormButton } from 'framework/form';
import { useShowContext } from 'framework/show';
import { useAuthorization } from 'framework/authorization';

type UpdateKpiButtonProps = {
  permissionToCheck: string;
  parenListReload: () => void;
};

const UpdateKpiValueButton = ({ permissionToCheck, parenListReload }: UpdateKpiButtonProps) => {
  const { data } = useShowContext();
  const { type, kpiValueId } = data.getData();
  const formatType = KPI_TYPES_UNIT_OPTIONS[type];
  const { isGranted } = useAuthorization();
  const { updateKPIValue, getUpdateValidationSchema } = useKPIService();

  return isGranted(permissionToCheck) ? (
    <>
      <ModalFormButton
        outline
        isVisible={isGranted(permissionToCheck)}
        disabled={kpiValueId === null}
        formTitle="Update"
        label="Update"
        submitFormFunc={formState =>
          updateKPIValue({
            ...formState,
            kpiValueId,
          } as UpdateValueType)
        }
        afterSubmit={{
          execute: () => {
            parenListReload();
          },
        }}
        getValidationSchemaFunc={getUpdateValidationSchema}
      >
        <FormSection>
          <TextInput label={`Value (${formatType})`} source="value" />
        </FormSection>
      </ModalFormButton>
    </>
  ) : (
    <></>
  );
};

export default UpdateKpiValueButton;
